import React, { ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useLocalStorage } from 'usehooks-ts';
import { DateProvider } from '@/components/context/DateContext';
import FreeCreditExitModal from '@/components/FreeCreditExitModal';
import SilverstripeContext, { defaultContext, AppState } from '../context/Silverstripe';
import Modal from '../ModalPortal';
import SEO from '../SEO';
import { useModal } from '../context/ModalContext';
import RouteProgress from './RouteProgress';

export interface MetaLayoutStateProps {
  children: ReactNode;
  appState?: AppState;
}

const ModalRouteHandler = () => {
  const router = useRouter();

  const { isModalOpen, hideModal, modalOptions } = useModal();

  useEffect(() => {
    const handleStop = () => {
      // hide any open modal after route change.
      if (isModalOpen && modalOptions.hideOnRouteChange) {
        hideModal();
      }
    };
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return function appStateCleanUp() {
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router.events, isModalOpen, hideModal, modalOptions.hideOnRouteChange]);

  return <></>;
};

const MetaLayout = ({ children, appState }: MetaLayoutStateProps) => {
  const state = appState || defaultContext;
  const router = useRouter();
  const [, setLocalStoragePromoCode] = useLocalStorage('firsttable.promoCode', {
    value: '',
    createdAt: '',
  });

  // Set the promo code in local storage if it exists in the query string
  useEffect(() => {
    if (router.query.code) {
      setLocalStoragePromoCode({
        value: router.query.code.toString(),
        createdAt: new Date().toISOString(),
      });
    }
  }, [router.query.code]);

  return (
    <SilverstripeContext.Provider value={state}>
      <RouteProgress />
      <ModalRouteHandler />
      <DateProvider>
        <SEO />
        {children}
        <FreeCreditExitModal />
        <Modal />
      </DateProvider>
    </SilverstripeContext.Provider>
  );
};

export default MetaLayout;
